import { Report } from '../../data/models/Reports'
import { dateFormatter as NewDateFormatter, DateFormatTypes as NewDateFormatterType } from '../../util/util'

const getPageSize = (size: number, totalPage: number) => {
  if (totalPage === 1) {
    return size
  }
  return size < 10 && size > 0 ? 10 : size
}

const parsePageData = (page: any) => {
  const totEle = +page?.totalElements ?? 0
  const totPage = totEle < 11 ? 1 : +page?.totalPages ?? 0
  const pageNumber = totEle < 11 ? 1 : page?.number ?? 1
  const pgSize = getPageSize(+page?.size ?? 0, totPage)
  return {
    size: pgSize,
    totalElements: +page?.totalElements ?? 0,
    totalPages: totPage,
    number: pageNumber,
  }
}

const downloadReportsListParser = (resp: any, pageNum: number) => {
  console.log('downloadReportsListParser ~ pageNum', pageNum)
  let errorObj
  if (resp?.error) {
    errorObj = resp?.error
  }

  const pageData = {
    size: resp?.data?.page?.size ?? 10,
    totalElements: resp?.data?.page?.totalElements ?? 0,
    totalPages: resp?.data?.page?.totalPages ?? 0,
    number: resp?.data?.page?.number ?? 0,
  }

  const getStatus = (status: string) => {
    const obj: any = {
      COMPLETED: 'Complete',
      INPROCESS: 'In Progress',
      FAILED: 'Failed',
    }
    return obj[status] ?? status
  }
  const pagination = parsePageData(pageData)
  const getContent = () => {
    return (
      resp?.data?.content?.map((data: any) => {
        const fromDate = data?.requestFrom?.split(' ')?.[0] ?? 'NA'
        const toDate = data?.requestTo?.split(' ')?.[0] ?? 'NA'
        return Report.create({
          // srno: resp?.data?.page?.number === 0 ? `${index + 1}.` : `${pageNum * 10 + (index + 1)}.`,
          requestFrom: NewDateFormatter(fromDate, NewDateFormatterType.MONTH_STRING_ISO_WO_CORRECTION),
          requestTo: NewDateFormatter(toDate, NewDateFormatterType.MONTH_STRING_ISO_WO_CORRECTION),
          requestTime: NewDateFormatter(data?.requestTime ?? 'NA', NewDateFormatterType.DD_MMM_YYYY_AM_PM),
          status: getStatus(data?.status),
          downloadDelete: data?.download ?? '',
          fileName: data?.fileName ?? '', // data?.fileName?.length > 15 ? data?.fileName?.slice(16, data?.fileName?.length) : data?.fileName ?? ''
          requestId: data?.requestId ?? '',
        })
      }) ?? []
    )
  }
  // const reports = getContent()
  // console.log('apptest output parsing response', JSON.parse(JSON.stringify(reports)))
  return { reports: getContent(), page: pagination, error: errorObj }
}
export { downloadReportsListParser }
